module.exports = __webpack_public_path__ + "img/hr-V-R-1-load-standup-base-shadow.bf10aa35.png";